import { Logger } from 'src/utils/Logger';

const INVITE_EMAIL_KEY = 'afternoon_invite_email';
const INVITE_TIMESTAMP_KEY = 'afternoon_invite_timestamp';
const TTL_MS = 5 * 60 * 1000; // 5 minutes

export const setInviteEmail = (email: string): void => {
  try {
    sessionStorage.setItem(INVITE_EMAIL_KEY, email);
    sessionStorage.setItem(INVITE_TIMESTAMP_KEY, Date.now().toString());
  } catch (e) {
    Logger.error('sessionStorage unavailable for invite email', e);
  }
};

export const getInviteEmail = (): string | null => {
  try {
    const email = sessionStorage.getItem(INVITE_EMAIL_KEY);
    const timestamp = sessionStorage.getItem(INVITE_TIMESTAMP_KEY);

    if (!email || !timestamp) return null;

    if (Date.now() - parseInt(timestamp, 10) > TTL_MS) {
      clearInviteEmail();
      return null;
    }
    return email;
  } catch {
    return null;
  }
};

export const clearInviteEmail = (): void => {
  try {
    sessionStorage.removeItem(INVITE_EMAIL_KEY);
    sessionStorage.removeItem(INVITE_TIMESTAMP_KEY);
  } catch (e) {
    Logger.error('sessionStorage unavailable for clearing invite email', e);
  }
};
